module.exports = __webpack_public_path__ + "img/qr2.f54eac68.png";